import {
  useMutateDeleteAllNotifications,
  useMutateDeleteAllReadNotifications,
  useMutateReadAllNotifications,
} from '@/hooks/mutation/useMutateUpdateNotifications';
import { useQueryNotifications } from '@/hooks/query/useQueryNotifications';
import { NotificationChannel } from '@heidi/schema/ml-scribe';
import { useQueryNotificationPreferences } from '@heidi/workspace/data';
import { useMemo } from 'react';

export const useNotificationsDropdownActions = () => {
  const { data: notifications, isPending: isNotificationsPending } =
    useQueryNotifications();
  const { data: notificationPreferences, isPending: isPreferencesPending } =
    useQueryNotificationPreferences();

  const isInmailNotificationEnabled = useMemo(
    () =>
      notificationPreferences?.subscribed_notification_channels.includes(
        NotificationChannel.INMAIL
      ) ?? false,
    [notificationPreferences]
  );

  const { mutate: mutateReadAllNotifications } = useMutateReadAllNotifications();
  const { mutate: mutateDeleteAllNotifications } = useMutateDeleteAllNotifications();
  const { mutate: mutateDeleteAllReadNotifications } =
    useMutateDeleteAllReadNotifications();

  return {
    isInmailNotificationEnabled,
    isPending: isNotificationsPending || isPreferencesPending,
    notifications,
    mutateReadAllNotifications,
    mutateDeleteAllNotifications,
    mutateDeleteAllReadNotifications,
  };
};
